var path = 'widget/lib/rpc/led-indicator.tpl.html';
var html = " <div class=tb-led-indicator layout=column> <div flex=20 class=title-container layout=row layout-align=\"center center\" ng-show=vm.showTitle> <span class=led-title>{{vm.title}}</span> </div> <div flex=\"{{vm.showTitle ? 80 : 100}}\" ng-style=\"{paddingTop: vm.showTitle ? '5px': '10px'}\" id=led-container layout=column layout-align=\"center center\"> <div class=led> </div> </div> <div class=error-container ng-style=\"{'background': vm.error.length ? 'rgba(255,255,255,0.25)' : 'none'}\" layout=row layout-align=\"center center\"> <span class=led-error>{{ vm.error }}</span> </div> <div id=text-measure></div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/widget/lib/rpc/led-indicator.tpl.html
// module id = 1535
// module chunks = 1